// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2Rjjj","colMin":"styles_colMin__1CU0A","colCheckbox":"styles_colCheckbox__8CGQF"};